import { ProcessState } from "../masterdata/models/processState-enum";
import { LabMDM } from "../masterdata/models/lab";
import { CarrierState } from "../masterdata/models/carrierState";
import { MachineType } from "../masterdata/models/machineType";
import { Machine } from "../masterdata/models/machine";
import { Printer } from "../masterdata/models/printer";
export  class LabProcessingRequest {
    createdBy:  string;
    containerBarcode:  string;
    machineBarcode: string;
    processState: ProcessState;
    lab: LabMDM;
    carrierState: CarrierState;
    machineType: MachineType;
    newContainerBarcode: string;
    machine: Machine;
    checked: boolean;
    printer: Printer;
}
